
class CartDrawer extends HTMLElement {
constructor() {
super();
this.addEventListener(
"keyup",
(evt) => evt.code === "Escape" && this.close()
);
this.querySelector("#CartDrawer-Overlay").addEventListener(
"click",
this.close.bind(this, false)
);
this.setHeaderCartIconAccessibility();
const headerAccount = document.querySelector(".header__account");
if (headerAccount) {
headerAccount.addEventListener("click", () => {
if (this.classList.contains("active")) {
this.close();
}
});
}
const search = document.querySelector(".header__search");
if (search) {
search.addEventListener("click", () => {
if (search.isOpen && this.classList.contains("active")) {
this.close();
}
});
}
const localization = document.querySelectorAll(".header__localization");
localization.forEach((localization) => {
localization.addEventListener("click", () => {
if (
localization.querySelector("button[aria-expanded=true]") &&
this.classList.contains("active")
) {
this.close();
}
});
});
}
setHeaderCartIconAccessibility() {
const cartLink = document.querySelector("#cart-icon-bubble");
cartLink.setAttribute("role", "button");
cartLink.setAttribute("aria-haspopup", "dialog");
cartLink.addEventListener("click", (event) => {
event.preventDefault();
if (!this.classList.contains("active")) this.open(cartLink);
else this.close();
});
cartLink.addEventListener("keydown", (event) => {
if (event.code.toUpperCase() === "SPACE") {
event.preventDefault();
if (!this.classList.contains("active")) this.open(cartLink);
else this.close();
}
});
}
open(triggeredBy) {
const search = document.querySelector(".header__search");
if (search) {
search.close();
}
const annBar = document.querySelector(".section-announcement");
if (annBar) annBar.classList.add("section-announcement-overlay");
if (triggeredBy) this.setActiveElement(triggeredBy);
const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
this.setSummaryAccessibility(cartDrawerNote);
setTimeout(() => {
this.classList.add("animate", "active");
});
this.addEventListener(
"transitionend",
() => {
const containerToTrapFocusOn = this.classList.contains("is-empty")
? this.querySelector(".drawer__inner-empty")
: document.getElementById("CartDrawer");
const focusElement =
this.querySelector(".drawer__inner") ||
this.querySelector(".drawer__close");
trapFocus(containerToTrapFocusOn, focusElement);
},
{ once: true }
);
document.body.classList.add("overflow-hidden-drawer");
}
close() {
const annBar = document.querySelector(".section-announcement");
if (annBar) annBar.classList.remove("section-announcement-overlay");
this.classList.remove("active");
removeTrapFocus(this.activeElement);
document.body.classList.remove("overflow-hidden-drawer");
}
setSummaryAccessibility(cartDrawerNote) {
cartDrawerNote.setAttribute("role", "button");
cartDrawerNote.setAttribute("aria-expanded", "false");
if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
cartDrawerNote.setAttribute(
"aria-controls",
cartDrawerNote.nextElementSibling.id
);
}
cartDrawerNote.addEventListener("click", (event) => {
event.currentTarget.setAttribute(
"aria-expanded",
!event.currentTarget.closest("details").hasAttribute("open")
);
});
cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
}
renderContents(parsedState) {
this.querySelector(".drawer__inner").classList.contains("is-empty") &&
this.querySelector(".drawer__inner").classList.remove("is-empty");
this.productId = parsedState.id;
this.getSectionsToRender().forEach((section) => {
const sectionElement = section.selector
? document.querySelector(section.selector)
: document.getElementById(section.id);
sectionElement.innerHTML = this.getSectionInnerHTML(
parsedState.sections[section.id],
section.selector
);
});
setTimeout(() => {
this.querySelector("#CartDrawer-Overlay").addEventListener(
"click",
this.close.bind(this, false)
);
this.open();
});
}
getSectionInnerHTML(html, selector = ".shopify-section") {
return new DOMParser()
.parseFromString(html, "text/html")
.querySelector(selector).innerHTML;
}
getSectionsToRender() {
return [
{
id: "cart-drawer",
selector: "#CartDrawer",
},
{
id: "cart-icon-bubble",
},
];
}
getSectionDOM(html, selector = ".shopify-section") {
return new DOMParser()
.parseFromString(html, "text/html")
.querySelector(selector);
}
setActiveElement(element) {
this.activeElement = element;
}
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
getSectionsToRender() {
return [
{
id: "CartDrawer",
section: "cart-drawer",
selector: ".drawer__inner",
},
{
id: "cart-icon-bubble",
section: "cart-icon-bubble",
selector: ".shopify-section",
},
];
}
}
customElements.define("cart-drawer-items", CartDrawerItems);
